import * as React from "react";
const CaroNextMobile = ( props ) => (
  <svg
    width={props.width ? props.width : "48"}
    height={props.height ? props.height : "48"}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={24} cy={24} r={23.5} stroke="#1F2022" />
    <path
      d="M24.2713 13.4065L34.6695 23.8047L24.2713 34.2029"
      stroke="#1F2022"
    />
    <line x1={34.668} y1={23.8594} x2={13.3357} y2={23.8594} stroke="black" />
  </svg>
);
export default CaroNextMobile;
